<template>
    <div>
        <b-row>
       
        <b-col cols="auto">
            <b-form-group>
                <label for="name" style="font-size: 0.8em">Filtro</label>
                <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
            </b-form-group>
        </b-col>

        <b-col cols="auto">
            <b-form-group>
                <label for="company" style="font-size: 0.8em">Status</label>
                <b-form-select id="company"
                    v-model="filters.statusId"
                    :plain="true"
                    :options="selectEventParticipantStatusDDL"
                    @change="refreshData"
                    :value="[null,'c']">
                </b-form-select>
            </b-form-group>
        </b-col>

        <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
            <b-form-group>
            <p></p>
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
            </b-form-group>
        </b-col>

        <b-col cols="auto" class="">
            <b-form-group >
                <label for="perPage">Linhas</label>
                <b-form-select v-model="table.perPage" id="perPage"
                :plain="true"
                :options="[5,10,20,50]">
                </b-form-select>
            </b-form-group>
        </b-col>
        
        </b-row>
        
  
        <b-table
            :items="filteredItems"
            :fields="table.fields"
            :select-mode="table.selectMode"
            responsive="sm"
            ref="selectableTable"
            selectable
            :primary-key="table.primaryKey"
            :tbody-transition-props="table.transProps"
            sort-icon-left
            :per-page="table.perPage"
            :current-page="table.currentPage"
            :busy="table.isBusy"
            hover
            striped
            style="min-height: 300px"
            >

            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Carregando...</strong>
                </div>
            </template>
            
            <!-- Example scoped slot for select state illustrative purposes -->
            <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                <span aria-hidden="true">&check;</span>
                <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                <span aria-hidden="true">&nbsp;</span>
                <span class="sr-only">Not selected</span>
                </template>
            </template>

            <template #cell(show_details)="row">
                <b-row>
                    <b-col cols="auto" class="mr-auto">
                        <b-form-group>
                        <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
            
            <template #row-details="row">
                <b-card>
                    <b-row v-show="row.item.summary && row.item.summary.length > 0">
                        <b-col class="small">Resumo</b-col>
                    </b-row>
                    <b-row>
                        <b-col class="text-primary">{{ row.item.summary }}</b-col>
                    </b-row>
                    <b-row v-show="row.item.content && row.item.content.length > 0">
                        <b-col class="small">Conteúdo</b-col>
                    </b-row>
                    <b-row>
                        <b-col class="text-primary">{{ row.item.content }}</b-col>
                    </b-row>
                    <b-row>
                        <b-col>{{ row.item.content }}</b-col>
                    </b-row>
                    <b-row>
                        <b-col><i>Publicado em <b>{{ row.item.publishedin }}</b> por <b>{{ row.item.publisher }}</b></i></b-col>
                    </b-row>
                </b-card>
            </template>
            
            <template v-slot:cell(originalValue)="data">
                {{ !isNaN(data.item.originalValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.originalValue) : '' }}
            </template>

            <template v-slot:cell(paymentValue)="data">
                {{ !isNaN(data.item.paymentValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.paymentValue) : '' }}
            </template>

            <template v-slot:cell(contact)="data">
                {{ data.item.companyName  }}
                <br>{{ data.item.contactName }}
                <br>Telefone: {{ data.item.contactPhone }}
                <br>E-mail: {{ data.item.contactEmail }}
            </template>

            <template v-slot:cell(costcenter)="data">
                {{ data.item.costCenterCode  }}<br>{{ data.item.costCenterName }}
            </template>

            <template v-slot:cell(st)="data">
                <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
            </template>
            
            <template v-slot:cell(ispublic)="data">
                <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
            </template>
            
        </b-table>
        <nav>
            <b-pagination :total-rows="totalRows" :per-page="table.perPage" v-model="table.currentPage" prev-text="Anterior" next-text="Próximo" />
        </nav>
  
    </div>
</template>


<script>
import Vue from 'vue'
import axios from "axios";
import { Switch as cSwitch } from '@coreui/vue'
  
/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
}
  
const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

export default {
    name: 'eventParticipantGridComponent',
    props: {
       item: {},
       companyId: 0
    },
    components: {
      cSwitch
    },
    data: () => {
        return {   
           eventParticipantStatusDDL: [],
           items: [],
           filters: {
            statusId: 0,
            key: '',
            status: 0
           },      
           switchLabelIcon: {
                dataOn: '\u2713',
                dataOff: '\u2715'
            },
           table: {
            fields: [
                //{key: 'show_details', label: "", thStyle: { width: "40px" } },
                //{key: 'id' },
                //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
                {key: 'name', label: 'Participante', sortable: true  },
                //{key: 'serviceDescription', label: 'Descrição do Serviço', sortable: true },
                //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
                //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
                //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
                //{key: 'description', label: 'Descrição', sortable: false },
                //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
                {key: 'status.name', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "200px" } },
                {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
            ],
            sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
            currentPage: 1,
            perPage: 50,
            isBusy: false,
            modes: ['multi', 'single', 'range'],
            selectMode: 'multi',
            primaryKey: "id",
            transProps: {
               name: 'flip-list'
            }
           }
        }
    },
    computed: {
        selectEventParticipantStatusDDL: function() {
            var list = [...this.eventParticipantStatusDDL]
            list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
            list.unshift({ value: '0' , text: '- Todos -' })
            return list
        },
        totalRows: function () { return this.getRowCount() },
        selectedItem() {
            return this.item
        },
        filteredItems() {
            try {
                return this.items.filter(item => {
                return (this.filters.key == '' || (
                    this.$utils.filterString(item.name, this.filters.key)
                    //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                    //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                    //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                    ))
                    && (this.filters.statusId==0 || item.statusId == this.filters.statusId )                  
                })
            }
            catch(e) {
                return this.items;
            }
        }
    },
    methods: {
        getRowCount: function () {
            if(this.items)
                return this.items.length
            else
                return 0;
        },

        async getEventParticipantStatus() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          this.isBusy = true;

          await axios.get(
              this.$store.state.ws_url + "/event/participant/status/ddl?companyId=" +  s.selectedItem.type.companyId  + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.eventParticipantStatusDDL = resp.data.obj;
          }
          ).catch(function (error) {
              console.log(error.message);            
          });

          this.isBusy = false;
    
        },

        async refreshData() {
       
            var s = this;
            var currentUser = this.$store.state.currentUser;
            this.isBusy = true;

            await axios.get(
                this.$store.state.ws_url + "/event/participant?companyId=" + s.selectedItem.type.companyId + "&eventId=" + s.selectedItem.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function (resp) {
                s.items = resp.data.obj;

            }).catch(function (error) {
                console.log("ERRO")
                console.log(error.message);
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Evento',
                    message: 'Sem permissão de acesso. Verifique e tente novamente.',
                    timeout: 3000
                })
            });

            this.isBusy = false;
        
        }
    },
    mounted: function() {
        this.getEventParticipantStatus()
        this.refreshData()
    }
}
</script>